import classNames from "classnames";
import React from "react";

export type FormGroupComponentProps = {
    row?: boolean;
    disabled?: boolean;
    check?: boolean;
    inline?: boolean;
};

export type FormGroupProps<T extends React.ElementType> =
    PolymorphicComponentProps<T, FormGroupComponentProps, "div" | "fieldset">;

const FormGroup = <T extends React.ElementType = "div">({
    className,
    row,
    disabled,
    check,
    inline,
    tag,
    ...attributes
}: FormGroupProps<T>) => {
    const Tag = tag || ("div" as React.ElementType);
    const classes = classNames(
        className,
        row ? "row" : false,
        check ? "form-check" : "form-group",
        check && inline ? "form-check-inline" : false,
        check && disabled ? "disabled" : false,
    );

    return <Tag {...attributes} className={classes} />;
};

export { FormGroup };
